import { Link } from "react-router-dom";
import { ArrowUpRight, Phone, Mail } from "lucide-react";
import { motion } from "framer-motion";
import { ParticlesGold } from "./ParticlesGold";
import { SplitTextReveal } from "./SplitTextReveal";

/**
 * FinalCTAParticles — fullscreen final CTA with golden particles background.
 */
export const FinalCTAParticles = () => (
  <section
    data-testid="final-cta-particles"
    className="relative bg-fd-bg border-t border-fd-border py-32 lg:py-48 pb-48 lg:pb-56 px-6 md:px-10 lg:px-14 overflow-hidden"
  >
    <ParticlesGold density={90} />
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(212,162,76,0.06),transparent_70%)] pointer-events-none"></div>

    <div className="relative max-w-[1400px] mx-auto text-center break-words">
      <div className="mono-label-gold mb-8 inline-flex items-center gap-3">
        <span className="w-8 h-px bg-fd-gold"></span>
        <span>Passez au pro</span>
        <span className="w-8 h-px bg-fd-gold"></span>
      </div>

      {/* One <h2> for the whole final headline — was two adjacent <h2>s before,
          which split the semantic heading in two and broke the page outline. */}
      <h2
        className="display-xl text-[clamp(2.25rem,9vw,10.5rem)] leading-[0.9]"
        aria-label="Tu sers. On approvisionne."
      >
        <SplitTextReveal
          text="Tu sers."
          as="span"
          mode="words"
          stagger={0.04}
          viewportMargin="200px"
          className="block text-fd-text"
        />
        <SplitTextReveal
          text="On approvisionne."
          as="span"
          mode="words"
          stagger={0.04}
          delay={0.08}
          viewportMargin="200px"
          className="block text-gradient-gold"
        />
      </h2>

      <motion.p
        initial={{ opacity: 0, y: 14 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, delay: 0.8 }}
        className="mt-10 font-body text-lg md:text-xl text-fd-text/60 max-w-xl mx-auto"
      >
        Ouvrez votre compte B2B. Un expert vous rappelle sous 24h avec un devis personnalisé.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 14 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, delay: 1.0 }}
        className="mt-12 flex flex-col sm:flex-row justify-center gap-4"
      >
        <Link to="/contact" data-cursor-hover className="btn-pill btn-primary-v2" data-testid="final-cta-primary">
          Ouvrir un compte pro <ArrowUpRight size={16} />
        </Link>
        <a href="tel:+33148680303" data-cursor-hover className="btn-pill btn-secondary-v2">
          <Phone size={14} /> 01 48 68 03 03
        </a>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, delay: 1.3 }}
        className="mt-20 flex flex-wrap justify-center gap-x-10 gap-y-3 mono-label"
      >
        <span>55-73 rue Blaise Pascal · 93600 Aulnay-sous-Bois</span>
        <span className="text-fd-text/20">/</span>
        <span>contact@fritesdorees.fr</span>
        <span className="text-fd-text/20">/</span>
        <span>Lundi–Vendredi · 8h–17h</span>
      </motion.div>
    </div>
  </section>
);
